export enum CompanyLabelType {
  Ycc = 'YCC',
  YccCustomer = 'YCC_CUSTOMER',
  YccWasel = 'YCC_WASEL',
  YccLand = 'YCC_LAND',
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
  Saas = 'SAAS',
  Ops = 'OPS',
  Sme = 'SME'
}
